'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

/* Components */

var _sidebarPanel = require('./sidebar/panel');

var _sidebarPanel2 = _interopRequireDefault(_sidebarPanel);

exports['default'] = _react2['default'].createClass({
  displayName: 'sidebar',

  render: function render() {

    var panelNodes = this.props.content.map(function (content) {
      return _react2['default'].createElement(
        _sidebarPanel2['default'],
        { key: content.key },
        content
      );
    });

    return _react2['default'].createElement(
      'div',
      { className: 'sidebar-component' },
      panelNodes
    );
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/sidebar.js
 **/